<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Noticias </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>
      </div>
      <div class="content_accion">
        <div>
          <v-text-field
            v-model="search"
            label="Búsqueda"
            prepend-inner-icon="mdi-magnify"
            single-line
            variant="outlined"
            hide-details
            class="filter"
          ></v-text-field>
        </div>
        <div>
          <v-btn
            icon="mdi-reload"
            size="small"
            variant="outlined"
            color="indigo-darken-3"
            class="mr-2 reload"
            v-on:click="getNoticias()"
          >
          </v-btn>
          <v-btn
            class="text-none mb-4"
            @click="openDialogRegistro('R')"
            prepend-icon="mdi-plus"
            color="indigo-darken-3"
          >
            Registrar
          </v-btn>
        </div>
      </div>
      <div class="container_table">
        <v-data-table
          class="content_table"
          :headers="headersTable"
          fixed-header
          :items="listNoticias"
          :search="search"
          :loading="loading"
        >
          <template v-slot:[`item.link_img`]="{ item }">
            <tr>
              <td>
                <a :href="item.link_img" target="_blank">{{ item.link_img }}</a>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <tr>
              <td>
                <div class="actions">
                  <v-tooltip activator="parent" location="top"
                    >Eliminar</v-tooltip
                  >
                  <v-btn
                    class="edit"
                    icon="mdi-delete"
                    color="error"
                    @click="openDilogEliminar(item)"
                  ></v-btn>
                </div>

                <div class="actions">
                  <v-tooltip activator="parent" location="top"
                    >Editar</v-tooltip
                  >
                  <v-btn
                    class="edit"
                    icon="mdi-pencil"
                    color="indigo-darken-3"
                    @click="openDialogRegistro('E', item)"
                  ></v-btn>
                </div>

                <div class="actions">
                  <v-tooltip activator="parent" location="top"
                    >Ver Imagen</v-tooltip
                  >
                  <v-btn
                    class="edit"
                    icon="mdi-eye"
                    color="indigo-darken-3"
                    @click="DescargarImg(item)"
                  ></v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>

  <!--Modal Registro-->
  <template>
    <v-dialog width="650" v-model="showDialog">
      <v-card :title="tituloDialogRegistro">
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <v-container>
            <v-row v-if="!isLoading">
              <v-col cols="12">
                <label>Título</label>
                <v-text-field
                  id="name"
                  v-model="titulo"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Imagen</label>
                <v-file-input
                  :rules="rulesImg"
                  v-model="inputImg"
                  accept="image/png, image/jpeg, image/jpg"
                ></v-file-input>
                <span class="image-dimension-warning">
                  <strong>Aviso:</strong> La dimensión recomendada es 1920px de
                  ancho por 1080px de alto (16:9). Si la imagen supera estas
                  dimensiones, es posible que no se visualice correctamente.
                </span>
              </v-col>
              <v-col cols="12">
                <label>Link</label>
                <v-text-field
                  id="linkImg"
                  v-model="linkImg"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <div class="content_load" v-if="isLoading">
              <v-progress-circular
                :size="100"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <i>Espere un momento</i>
            </div>
          </v-container>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialog"
          ></v-btn>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            :loading="isLoading"
            @click="validateInputs()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!--Dialog de eliminacion-->
  <template>
    <v-dialog v-model="dialogDelete" width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirmación</span>
        </v-card-title>
        <v-card-text>
          <div v-if="!isLoadingEliminar">
            <div class="text-center">
              <img class="img-graphics" src="@/assets/images/warning.png" />
            </div>
            <div class="description-text">
              <p>¿Está seguro de eliminar la noticia?</p>
            </div>
          </div>
          <div class="content_load" v-if="isLoadingEliminar">
            <v-progress-circular
              :size="100"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <i>Espere un momento</i>
          </div>
        </v-card-text>
        <v-card-actions class="actions-buttons">
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogDelete = false"
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            >Cerrar</v-btn
          >
          <v-btn
            :loading="isLoadingEliminar"
            @click="deleteImage"
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</template>

<script>
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";
import { CarruselService } from "@/services/CarruselService.js";

export default {
  name: "NoticiasComponent",
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      search: "",
      listNoticias: [],
      headersTable: [
        { title: "Título", key: "titulo" },
        { title: "Link", key: "link_img" },
        { title: "Agregado Por", key: "agregado_por" },
        { title: "Fecha Creación", key: "updated_at" },
        { title: "Acciones", key: "actions" },
      ],
      loading: true,
      showDialog: false,
      isLoading: false,
      titulo: "",
      linkImg: "",
      rulesImg: [
        (value) => {
          return (
            !value ||
            !value.length ||
            value[0].size < 2000000 ||
            "La imagen debe de pesar menos de 2 MB!"
          );
        },
      ],
      inputImg: null,
      idNoticiaG: "",
      dialogDelete: false,
      isLoadingEliminar: false,
      tituloDialogRegistro: "Crear Noticia",
      modeForm: "R",
    };
  },
  beforeMount() {
    this.getNoticias();
  },
  methods: {
    getNoticias: async function () {
      this.loading = true;
      await CarruselService.getImages()
        .then((resp) => {
          if (!resp.error) {
            this.listNoticias = resp.response;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          console.log("ERROR: Obtener imagenes, ", error);
        });
    },
    openDialogRegistro(tipo, data) {
      if (tipo == "R") {
        this.modeForm = "R";
        this.tituloDialogRegistro = "Crear Noticia";
      }

      if (tipo == "E") {
        this.modeForm = "E";
        this.tituloDialogRegistro = "Editar Noticia";
        this.titulo = data.titulo;
        this.linkImg = data.link_img;
        this.idNoticiaG = data.id_noticia;
      }
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
      this.titulo = "";
      this.linkImg = "";
      this.inputImg = null;
    },
    validateInputs() {
      if (this.titulo === "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "El título es requerido",
        };
        return false;
      }

      this.isLoading = true;
      if (this.modeForm == "E") {
        this.editarImg();
      } else {
        this.saveImage();
      }
    },
    saveImage: async function () {
      const formData = new FormData();
      formData.append("titulo", this.titulo);
      formData.append("url_img", this.inputImg[0]);
      if (this.linkImg == null) {
        formData.append("link_img", "");
      } else {
        formData.append("link_img", this.linkImg);
      }

      await CarruselService.saveImage(formData)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se registró exitosamente!",
            };

            this.getNoticias();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          console.log("ERROR: SAVEIMG: ", err);
        });
      this.isLoading = false;
      this.closeDialog();
    },
    openDilogEliminar(item) {
      this.idNoticiaG = item.id_noticia;
      this.dialogDelete = true;
    },
    deleteImage: async function () {
      this.isLoadingEliminar = true;
      let idNoticia = await CarruselService.encriptar(this.idNoticiaG);
      await CarruselService.deleteImage(idNoticia.msg)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se eliminó exitosamente!",
            };

            this.getNoticias();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          console.log("ERROR: DeleteImage: ", err);
        });
      this.dialogDelete = false;
      this.isLoadingEliminar = false;
      this.search = "";
    },
    DescargarImg(item) {
      window.open(`${item.url_img}`, "_blank");
    },
    editarImg: async function () {
      let idNoticia = await CarruselService.encriptar(this.idNoticiaG);
      const formData = new FormData();
      formData.append("titulo", this.titulo);
      if (this.inputImg == null) {
        formData.append("url_img", "");
      } else {
        formData.append("url_img", this.inputImg[0]);
      }

      if (this.linkImg == null) {
        formData.append("link_img", "");
      } else {
        formData.append("link_img", this.linkImg);
      }

      formData.append("id_noticia", idNoticia.msg);
      await CarruselService.editImg(formData)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se editó exitosamente!",
            };

            this.getNoticias();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          console.log("ERROR: EditarImg: ", err);
        });

      this.isLoading = false;
      this.closeDialog();
    },
  },
};
</script>
<style>
.reload {
  margin-top: -2vh;
}

.content_table {
  overflow: auto;
}

.content_accion {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.content_load {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.actions {
  display: flex;
  align-items: center;
  float: left;
  margin-right: 1vh;
  width: 9vh !important;
  height: 9vh !important;
}

.image-dimension-warning {
  color: #ff5722; /* Color de advertencia */
  font-size: 14px;
  margin-top: 8px;
  display: block;
}
</style>
